<template>
    <p class="text-center py-4">
        Požadovaná stránka nebyla nalezena.
        <br/><br/>
        The requested URL was not found on this server.
    </p>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'NotFoundpage',
});
</script>
